module.exports = __webpack_public_path__ + "img/bookings_mobile.5fe7aa78.png";